<template>
   <teleport to="body">
      <div>
         <button
            ref="btnModalRef"
            style="display: none"
            data-bs-toggle="modal"
            data-bs-target="#image-cropper"
            id="popup-cropper-btn"
         />
         <div
            class="modal fade modal-custom"
            id="image-cropper"
            tabindex="-1"
            role="dialog"
            aria-labelledby="image-cropper"
            aria-hidden="true"
         >
            <div class="modal-dialog" role="document">
               <div class="modal-custom__content">
                  <div class="modal-custom__header">
                     <span class="modal-custom__title"> {{ $t('avatar.choose_photo') }}</span>
                  </div>
                  <div class="modal-custom__body">
                     <cropper
                        class="cropper"
                        ref="cropper"
                        :src="image"
                        :stencil-props="{
                           resizable: false,
                           aspectRatio: 1 / 1
                        }"
                        :canvas="{
                           height: 500,
                           width: 500
                        }"
                     ></cropper>
                     <div class="modal-custom__btn">
                        <button
                           class="button button--normal button--medium"
                           type="button"
                           data-bs-dismiss="modal"
                           @click="$emit('cancel')"
                        >
                           {{ $t('buttons.cancel') }}
                        </button>
                        <button
                           class="button button--primary button--medium"
                           type="button"
                           data-bs-dismiss="modal"
                           @click="onSave"
                        >
                        {{ $t('buttons.save') }}   
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </teleport>
</template>
<script>
// import $ from 'jquery'
// import i18n from '@/plugins/i18n'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import 'vue-advanced-cropper/dist/theme.compact.css'
import Teleport from 'vue2-teleport'
export default {
   components: { Cropper, Teleport },
   props: {
      image: String, // Type: {title: "", content: "", cancelButton: "", confirmButton: "", confirmedData: {}},
      onConfirm: Function,
      onCancel: {
         type: Function,
         default: () => {}
      },
      onClose: {
         type: Function,
         default: () => {}
      }
   },
   data() {
      return {
         showedData: {}
      }
   },
   methods: {
      showModal() {
         this.$refs.btnModalRef.click()
      },
      onSave() {
         const { canvas } = this.$refs.cropper.getResult()
         if (canvas) this.$emit('save', canvas.toDataURL('image/png'))
      }
   }
}
</script>

<style lang="scss" scoped>
.modal-custom {
   &__content {
      position: relative;
      padding: 15px;
   }
   &__header {
      display: flex;
      justify-content: center;
   }

   &__action {
      position: absolute;
      top: 20px;
      right: 20px;
      height: 20px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bs-primary);
      border-radius: 50%;
      padding: 0;

      i {
         color: var(--bs-white);
         font-size: 15px;
         font-weight: bolder;
      }
   }

   &__title {
      font-size: 20px;
      font-weight: bold;
   }

   &__btn {
      margin: 30px 0 0;
      gap: 20px;

      .button {
         margin: 0;
         border: 1px solid var(--bs-primary);
         color: #000000;
         font-weight: bold;
         font-size: 15px;
         border-radius: 100px;
         height: 44px;

         &.button--primary {
            background: var(--bs-primary);
            color: var(--bs-white);
         }
      }
   }
}

.cropper {
   height: 400px;
   background: #ddd;
}
// ::v-deep .vue-rectangle-stencil__preview {
//    border-radius: 10px;
// }
// ::v-deep .vue-simple-line {
//    display: none;
// }
// ::v-deep .vue-simple-handler {
//    display: none;
// }

::v-deep .vue-simple-handler-wrapper {
   width: 36px;
   height: 36px;
   // &--east-north {
   //    border-top: 2px solid #000;
   //    border-right: 2px solid #000;
   //    border-top-right-radius: 10px;
   // }
   // &--west-north {
   //    border-top: 2px solid #000;
   //    border-left: 2px solid #000;
   //    border-top-left-radius: 10px;
   // }
   // &--east-south {
   //    border-bottom: 2px solid #000;
   //    border-right: 2px solid #000;
   //    border-bottom-right-radius: 10px;
   // }

   // &--west-south {
   //    border-bottom: 2px solid #000;
   //    border-left: 2px solid #000;
   //    border-bottom-left-radius: 10px;
   // }
}
::v-deep .vue-rectangle-stencil__preview {
   &::before,
   &::after {
      display: none;
   }
}

.blur {
   filter: blur(5px);
}
</style>
